import { BreadCrumbs } from "@alliancesafetycouncil/asc-breadcrumbs";
import PageTitle from "@alliancesafetycouncil/asc-page-title";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getCompanies } from "../../../actions/Companies/Companies";
import { getSite } from "../../../actions/Sites/Sites";
import FormContainer from "../../../components/FormContainer/FormContainer";
import { HeaderActions } from "../../../components/HeaderActions/HeaderActions";
import { Header } from "../../../containers/Layout/Header";
import { states } from "../../../library/Utilities";
import EditSiteForm from "./EditSiteForm";

class EditSite extends Component {
  constructor(props) {
    super(props);

    this.state = {
      siteId: props.match.params.id,
      states: states,
    };
  }

  setRef = (ref) => {
    this.setState({
      editorRef: ref,
    });
  };

  componentDidMount() {
    this.props.GetSite(this.state.siteId);
    this.props.GetCompanies("asc", 100, 0, "id");
  }

  render() {
    const { companies, details } = this.props;
    const { states } = this.state;

    const links = [
      {
        title: details.name,
        link: "/#/sites",
      },
      {
        title: "Edit Site",
      },
    ];

    return (
      <div className="flex flex-col bg-blue-50 h-full">
        <Header>
          <div className="pr-6 w-4/6">
            <BreadCrumbs crumbs={links} />
          </div>
          <div className="w-2/6">{this.props.auth && <HeaderActions />}</div>
        </Header>
        <div className="row header no-flex mx-4 h-20 flex items-center">
          <PageTitle>
            <i className="fal fa-building text-orange-500 mr-2"></i>Edit Site
          </PageTitle>
        </div>
        <div className="mb-4 content flex-auto mx-4">
          <FormContainer
            {...this.props}
            setRef={this.setRef}
            entity="sites"
            action="edit"
            redirect={`/sites`}
            Form={EditSiteForm}
            companies={companies}
            states={states}
            initialValues={{
              ...details,
              company_id: details.company.id,
            }}
            handleValues={(values) => {
              const payload = {
                name: values.name,
                contact: values.contact,
                address: values.address,
                city: values.city,
                state: values.state,
                zip: values.zip,
                notes: this.state.editorRef.getContent(),
              };

              return payload;
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    details: state.siteService.details,
    companies: state.companyService.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetSite: (siteId) => dispatch(getSite(siteId)),
    GetCompanies: (direction, limit, offset, sort) => dispatch(getCompanies(direction, limit, offset, sort)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditSite);
